export default function actions() {
  $(document).on('click', '#new-integration-easy-recrue', (e) => {
    e.preventDefault();
    $('#easy-recrue-integration-form').toggleClass('is-hidden');
  });
}
